// import { MemberActionType } from '../../actions/member/memberTypes';
import { OrderVoActionType } from '@/reducers/V2/V2Actions/OrderVo/OrderVoTypes';

const initialState: any = {
  alerts: [],
  menuLocale: 'zh-tw',
  status: null,
  isPostPay: false,
  serveType: '',
  customId: '',
  preorderTime: '',
  seatOvertimeMins: null,
  seatedAt: null,
  seats: [],
  conditions: {},
  couponBarCodes: [],
  redeemRules: [],
  orderItems: [],
  orderPromotions: [],
  serviceFee: 0,
  shareMealFee: 0,
  total: 0,
  pagerCode: '',
  // customer info
  customerName: '',
  customerPhone: '',
  customerAreaCode: {},
  address: '',
  comments: '',
  cartPayMethod: '',

  // waitingInfo 等待數量
  waitingInfo: { count: 0, enabled: false, minutes: 0, mode: '', type: '' },

  // TODO:
  table: {},
};

const OrderVoReducer: (state: any, action: any) => any = (
  state = initialState,
  action
) => {
  const { type, payload } = action;

  switch (type) {
    case OrderVoActionType.SET_ORDER_VO_ALERTS:
      return {
        ...state,
        alerts: payload,
      };
    case OrderVoActionType.SET_ORDER_VO_MENU_LOCALE:
      return {
        ...state,
        menuLocale: payload,
      };
    case OrderVoActionType.SET_ORDER_VO_SERVETYPE:
      return {
        ...state,
        serveType: payload,
      };
    case OrderVoActionType.SET_ORDER_VO_STATUS:
      return {
        ...state,
        status: payload,
      };
    case OrderVoActionType.SET_ORDER_VO_IS_POSTPAY:
      return {
        ...state,
        isPostPay: payload,
      };
    case OrderVoActionType.SET_ORDER_VO_CUSTOMID:
      return {
        ...state,
        customId: payload,
      };
    case OrderVoActionType.SET_ORDER_VO_PREORDERTIME:
      return {
        ...state,
        preorderTime: payload,
      };
    case OrderVoActionType.SET_ORDER_VO_ADDRESS:
      return {
        ...state,
        address: payload,
      };
    case OrderVoActionType.SET_ORDER_VO_SEAT_OVERTIME_MINS:
      return {
        ...state,
        seatOvertimeMins: payload,
      };
    case OrderVoActionType.SET_ORDER_VO_SEATED_AT:
      return {
        ...state,
        seatedAt: payload,
      };
    case OrderVoActionType.SET_ORDER_VO_SEATS:
      return {
        ...state,
        seats: payload,
      };
    case OrderVoActionType.SET_ORDER_VO_CONDITIONS:
      return {
        ...state,
        conditions: payload,
      };

    case OrderVoActionType.SET_ORDER_VO_COUPON_BARCODES:
      return {
        ...state,
        couponBarCodes: payload,
      };
    case OrderVoActionType.SET_ORDER_VO_REDEEM_RULES:
      return {
        ...state,
        redeemRules: payload,
      };
    case OrderVoActionType.SET_ORDER_VO_ORDER_ITEMS:
      return {
        ...state,
        orderItems: payload,
      };
    case OrderVoActionType.SET_ORDER_VO_ORDER_PROMOTIONS:
      return {
        ...state,
        orderPromotions: payload,
      };
    case OrderVoActionType.SET_ORDER_VO_COMMENTS:
      return {
        ...state,
        comments: payload,
      };
    case OrderVoActionType.SET_ORDER_VO_SERVICE_FEE:
      return {
        ...state,
        serviceFee: payload,
      };
    case OrderVoActionType.SET_ORDER_VO_SHAREMEEL_FEE:
      return {
        ...state,
        shareMealFee: payload,
      };
    case OrderVoActionType.SET_ORDER_VO_TOTAL:
      return {
        ...state,
        total: payload,
      };
    case OrderVoActionType.SET_ORDER_VO_CUSTOMER_NAME:
      return {
        ...state,
        customerName: payload,
      };
    case OrderVoActionType.SET_ORDER_VO_CUSTOMER_PHONE:
      return {
        ...state,
        customerPhone: payload,
      };
    case OrderVoActionType.SET_ORDER_VO_CUSTOMER_AREA_CODE:
      return {
        ...state,
        customerAreaCode: payload,
      };
    case OrderVoActionType.SET_ORDER_VO_PAY_METHOD:
      return {
        ...state,
        cartPayMethod: payload,
      };
    case OrderVoActionType.SET_ORDER_VO_WAITING_INFO:
      return {
        ...state,
        waitingInfo: payload,
      };
    case OrderVoActionType.SET_ORDER_VO_PAGER_CODE:
      return {
        ...state,
        pagerCode: payload,
      };

    default:
      return state;
  }
};

export default OrderVoReducer;
